// i18n area 'apps' — locale uk-UA (task #171, onda 3): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/apps.uk-UA.meta.json.
import type { enUS } from './apps'

export const ukUA: typeof enUS = {

  // Застосунки, хвиля 1 (Annex R): контейнери podman під наглядом воркера на
  // оголошеному вузлі; образ = lockfile branch@digest (Annex Q) з політикою
  // pinned/tracking; підключення L3 без тегу зі статичною IP-адресою.
  apps: {
    title: 'Застосунки',
    create: 'Створити застосунок',
    createTitle: 'Створити застосунок',
    editTitle: 'Редагувати застосунок',
    name: 'Назва',
    nameHint: 'DNS-1123, унікальна в межах скоупа — незмінна після створення.',
    node: 'Вузол',
    nodeHint: 'Вузол-учасник, який його обслуговує — явне розміщення (планувальник буде згодом).',
    image: 'Образ',
    editImageHint: 'Нове посилання наново розв’язується через довідник — це і є жест закріплення/відкату.',
    imagePolicy: 'Політика',
    policyPinned: 'pinned',
    policyTracking: 'tracking',
    policyPinnedHint: 'Дайджест зсувається лише за командою.',
    policyTrackingHint: 'Автоматичний перехід на новий дайджест, щойно оновлення зсуває гілку.',
    archMovePolicy: 'Переміщення cross-arch',
    archMoveRefuse: 'refuse',
    archMoveReresolve: 'reresolve',
    archMovePolicyHint: "Що відбувається, якщо app переміщають на node іншої архітектури: refuse відхиляє переміщення, reresolve заново розв'язує lockfile з branch на новій arch — вміст змінюється, і відповідь називає зміну digest.",
    network: 'Мережа',
    networkHint: 'Підключення L3 без тегу: логічна мережа фабрики (рекомендовано — шлюз і DNS з її єдиного джерела), оверлей або голий бридж хоста (не рекомендовано).',
    overlayPrefix: 'оверлей:',
    fabricPrefix: 'фабрика:',
    bridgePrefix: 'бридж хоста:',
    ipAssignment: 'Призначення IP',
    ipStatic: 'Статичне',
    ipAuto: 'Автоматичне (IPAM)',
    ipAssignmentHint_static: 'Адресу задаєте ви, зараз.',
    ipAssignmentHint_auto: 'IPAM обирає вільну адресу з діапазонів мережі, зарезервованих для TVirt.',
    bridgeDiscouraged: 'Голий бридж хоста — НЕ РЕКОМЕНДОВАНО: TVirt нічого не знає про його адресацію, тож шлюз і DNS доводиться задавати вручну. Рекомендований шлях — логічна мережа фабрики.',
    ip: 'IP',
    ipHint: 'Статична IPv4 у підмережі підключення.',
    ipCidrHint: 'У формі CIDR на голому бриджі (напр. 192.168.1.10/24) — префікс нізвідки вивести.',
    gateway: 'Шлюз',
    gatewayManualHint: 'Вручну — голий бридж нічого не виводить.',
    dnsServers: 'DNS-сервери',
    dnsManualHint: 'Вручну, через кому — щонайменше один.',
    rootKind: 'Корінь',
    rootEphemeral: 'ефемерний',
    rootPersistent: 'постійний',
    rootEphemeralHint: 'Відтворюється з образу за кожного перестворення; живе в ефемерному сховищі кластера.',
    rootEphemeralHintNamed: 'Відтворюється з образу за кожного перестворення; живе в ефемерному сховищі кластера ({name}).',
    rootPersistentHint: 'Переживає перезапуски; живе у сховищі, яке оберете ви.',
    rootStorage: 'Сховище кореня',
    editRootStorageHint: 'Корінь наново розгортається в новому пулі — наявні дані НЕ переміщуються самі.',
    volumes: 'Томи',
    volumeAdd: 'Додати том',
    volumeName: 'Назва',
    volumeMountPath: 'Шлях монтування',
    volumeKind: 'Тип',
    volumeStorage: 'Сховище',
    devices: 'Пристрої',
    deviceClassHint: 'Запитується КЛАС (тег gpu-device або usb-device), ніколи не конкретний пристрій: оголошений вузол повинен мати пристрій, позначений для застосунків. Кілька застосунків можуть використовувати той самий пристрій — контейнер ділить його, а не забирає в хоста.',
    deviceSlot: 'Слот',
    deviceTag: 'Тег',
    deviceValue: 'Клас',
    deviceUnresolved: "зараз нічого не розв'язується",
    noDeviceTags: 'Ще немає тега виду gpu-device або usb-device: створи його і признач пристроям, позначеним для застосунків.',
    env: 'Середовище',
    envHint: 'По одному КЛЮЧ=значення на рядок.',
    secretEnvTitle: 'Секретні змінні',
    secretEnvNotice: 'Секретне значення більше ніколи не повертається з API: ніхто його не перечитає, навіть той, хто його записав. У контрольній точці воно подорожує запечатаним майстер-паролем, тож відновлення без майстер-пароля попросить ввести його знову.',
    secretEnvPromote: 'Зробіть секретною одну зі змінних, записаних вище:',
    secretEnvAdd: 'Додати секретну змінну',
    secretEnvName: 'Назва',
    secretEnvValue: 'Значення',
    secretEnvKept: 'збережено — залиште порожнім, щоб не змінювати',
    secretEnvWithdrawWarning: 'Щоб перестати вважати секретною змінну, яка вже такою є, запишіть їй нове значення: зняти лише маркер означало б ПРОЧИТАТИ те, що зі сховища не виходить. Натомість вилучення змінної її стирає.',
    secretEnvChip: 'секретно',
    startNow: 'Запустити одразу (інакше застосунок народжується зупиненим)',
    deletePersistentIntro: 'Цей застосунок має постійні дані — виберіть, що з ними зробити:',
    deleteKeepData: 'Зберегти дані (директорії лишаються у своїх сховищах, осиротілі)',
    deletePurgeData: 'Видалити також дані',
    phase: 'Фаза',
    phase_running: 'Виконується',
    phase_stopped: 'Зупинений',
    phase_error: 'Помилка',
    phase_unknown: 'Невідома',
    desiredState: 'Бажаний стан',
    wantedRunning: 'виконується',
    wantedStopped: 'зупинений',
    start: 'Запустити',
    stop: 'Зупинити',
    restart: 'Перезапустити',
    refreshImage: 'Оновити образ (прийняти новий @current)',
    logs: 'Журнал',
    logsTitle: 'Журнал',
    logsEmpty: 'Жодного захопленого виводу.',
    shell: 'Shell',
    shellTitle: 'Shell',
    shellUnavailable: 'App не запущена — shell потрібен живий контейнер. Її логи можна читати в будь-якому стані.',
    shellConnect: 'Підключитися',
    shellDisconnect: 'Відключитися',
    shellExited: 'Сесія завершилася з кодом виходу {code}.',
    shellEndedWithoutStatus: 'Сесія завершилася без статусу виходу: {reason}',
    shellRevoked: 'Ticket сесії більше не дійсний — він сплив, або вхід, який його відкрив, було відкликано.',
    shellHint: 'Натисніть на чорне поле і друкуйте: клавіші доходять до контейнера. Ctrl+C і стрілки працюють; exit закриває shell.',
    shellStatus: {
      connecting: 'Підключення…',
      connected: 'Підключена',
      ended: 'Завершена'
    },
    deleteRunningError: 'Для {name} бажаний стан — «виконується»: спершу зупиніть застосунок.',

    // Стандартний діалог (раунд #156): вкладки деталей і поля контракту, яких
    // бракувало — кожне поле застосунку видиме, замки з поясненням.
    tabs: {
      general: 'Загальне',
      image: 'Образ',
      network: 'Мережа',
      storage: 'Сховище',
      devices: 'Пристрої',
      observed: 'Спостережене'
    },
    attachment: 'Підключення',
    runningDigest: 'Дайджест, що виконується',
    lastError: 'Остання помилка',
    reportObservedAt: 'Останній звіт воркера',
    desiredStateLock: 'Ним керують дії «Запустити»/«Зупинити» — ніколи пряме редагування.',
    ipEditDisabledHint: 'Редагується лише за статичного призначення.',
    derivedFromNetworkHint: 'Похідне від єдиного джерела мережі — вручну лише на голому бриджі зі статичною адресою.',
    ephemeralUnset: 'не налаштовано',
    ephemeralMissing: 'Ефемерне сховище застосунків не налаштоване — створення застосунку з ефемерними частинами (корінь чи томи) відхиляється, доки ви його не задасте.',
    ephemeralCurrent: 'Ефемерне сховище застосунків: {name}',
    ephemeralMissingCreate: 'Цей застосунок має ефемерні частини, але ефемерне сховище застосунків не задано — створення буде відхилено. Спершу задайте його з банера сторінки «Застосунки».',
    setEphemeral: 'Задати ефемерне сховище',
    changeEphemeral: 'Змінити ефемерне сховище',
    setEphemeralTitle: 'Задати ефемерне сховище застосунків',
    changeEphemeralTitle: 'Змінити ефемерне сховище застосунків',
    ephemeralStorageHint: 'ТИПОВЕ значення кластера: dir-подібний пул, де живуть корені та ефемерні томи кожного застосунку, окрім перевизначення, оголошеного самим застосунком. Зміна не гаряча й нічого не перезапускає: діє з наступного запуску кожного застосунку — ефемерні дані не переміщуються.',
    ephemeralPool: 'Пул сховища',
    ephemeralOverride: 'Ефемерне сховище (перевизначення для застосунку)',
    ephemeralOverrideInherit: 'Успадкувати типове значення кластера',
    ephemeralOverrideInheritNamed: 'Успадкувати типове значення кластера ({name})',
    ephemeralOverrideHint: 'Пул окремого застосунку під корінь і ефемерні томи — залиште порожнім, щоб успадкувати типове значення кластера. Зміна не гаряча й нічого не перезапускає: діє з наступного запуску (ефемерні дані відроджуються порожніми в новому пулі) і потребує дозволу app.ephemeralStorage.set.',
    ephemeralOverrideTag: 'перевизначення',

    imageAnyBranch: 'Усі гілки',
    imageBranchHint: 'Звужує образи до названих цією гілкою; без гілки видно всі образи репозиторію.',
    imageDigestHint: 'Вміст: обирається з таблиці дайджестів, яка несе його походження та архітектуру. Та сама гілка пропонує по одному на архітектуру, і вони не є взаємозамінними.',
    imageLockfile: 'Розв’язане посилання',
    imageNoImages: 'Для цього репозиторію немає образів у кеші — завантаж один із розділу Образи OCI.',
    imageHeadNotCached: 'немає в кеші — завантажується під час запуску',
    imageNoRegistries: 'Не зареєстровано жодного репозиторію: зареєструй один, щоб можна було обрати образ.',
    imageChosenHint: 'Образ обирається каскадом у діалозі редагування: посилання ніколи не набирають вручну.',
    registerRepositoryHint: 'Реєстрація нічого не завантажує: вона робить репозиторій спостережуваним, щоб образ можна було обрати, не виходячи з цього діалогу.',
    registerRepositoryBranchHint: 'Необов’язково: перша гілка для спостереження (напр. latest).',
    registerRepositoryElsewhere: 'Шуканий репозиторій не зареєстровано: реєстрація робиться в розділі Образи OCI тим, хто має дозвіл.'
  },

  // Шаблони CT (раунд K2 #63): МАТЕРІАЛІЗОВАНІ об’єкти CT — імпорт із каталогу
  // є єдиним входом; файли вивантажуються всередину каталогів.
  cts: {
    createAction: 'Створити CT',
    createTitle: 'Створити контейнер із шаблона',
    createError: 'Контейнер не створено',
    template: 'Шаблон CT',
    noTemplates: 'Немає шаблонів CT — імпортуйте один із розділу «Шаблони CT»',
    resources: 'Ресурси',
    node: 'Вузол',
    phase: {
      defined: 'Ніколи не вмикався',
      materializing: 'Матеріалізується',
      ready: 'Готовий',
      starting: 'Запускається',
      running: 'Виконується',
      stopping: 'Зупиняється',
      stopped: 'Зупинений',
      deleting: 'Видаляється',
      error: 'У стані помилки'
    },
    actions: {
      start: 'Запустити',
      stop: 'Зупинити',
      restart: 'Перезапустити',
      markTemplate: 'Підвищити до шаблона CT',
      error: 'Дію відхилено'
    },
    markTemplate: {
      confirmTitle: 'Підвищити «{name}» до шаблона CT?',
      confirmBody: 'Контейнер залишає цей список і переходить до «Шаблонів CT», одразу готовий породжувати нові CT. Метадані лишаються редагованими, і ви будь-коли можете повернути його до CT.',
      confirm: 'Підвищити',
      moved: 'Тепер «{name}» — шаблон CT; знайдете його в розділі «Шаблони CT».'
    },
    stopCause: {
      api: 'Зупинено з TVirt',
      'ct-exit': 'Контейнер завершився сам',
      'host-reboot': 'Загинув разом із перезавантаженням вузла',
      'start-failed': 'Запуск не вдався — помилка завдання каже, чого бракує і як це виправити'
    },

    console: 'Консоль',
    consoleUnavailable: 'Контейнер не виконується — консолі потрібен живий контейнер. Його журнал натомість читається в будь-якому стані.',
    consoleNoTemplate: 'Шаблон ніколи не виконується, тож не має консолі: створіть із нього CT і відкрийте його консоль.',
    consoleConnect: 'Під’єднатися',
    consoleDisconnect: 'Від’єднатися',
    consoleReconnect: 'Перез’єднатися',
    consoleTakenBy: 'Цю консоль перехопив інший оператор ({user}). Одна консоль на контейнер: перез’єднання забирає її назад.',
    consoleHint: 'Клацніть чорне поле і друкуйте: клавіші доходять до контейнера. Ctrl+C і стрілки працюють.',
    consoleEndpointDown: 'Точку доступу консолі не вдається відкрити на вузлі, який обслуговує container: {cause}',
    shell: 'Shell',
    shellTitle: 'Shell',
    shellUnavailable: 'Container не запущений — shell потребує живого container. Його логи можна читати в будь-якому стані.',
    shellNoTemplate: 'Template ніколи не запускається, тому не має shell: створіть із нього CT і відкрийте його shell.',
    shellConnect: 'Підключитися',
    shellDisconnect: 'Відключитися',
    shellExited: 'Сесія завершилася з кодом виходу {code}.',
    shellEndedWithoutStatus: 'Сесія завершилася без статусу виходу: {reason}',
    shellRevoked: 'Ticket сесії більше не дійсний — він сплив, або вхід, який його відкрив, було відкликано.',
    shellHint: 'Натисніть на чорне поле і друкуйте: клавіші доходять до контейнера. Ctrl+C і стрілки працюють; exit закриває shell.',
    shellStatus: {
      connecting: 'Підключення…',
      connected: 'Підключена',
      ended: 'Завершена'
    },
    rootPassword: 'Пароль root',
    rootPasswordHint: 'Записується один раз у скопійований rootfs (як hash, більше не показується). Образи дистрибутивів не мають пароля root: без нього shell — єдиний вхід.',
    sshKeys: 'Публічні SSH-ключі root',
    sshKeysHint: 'По одному публічному ключу OpenSSH на рядок, у root/.ssh/authorized_keys.',
    consoleStatus: {
      connecting: 'З’єднання…',
      connected: 'З’єднано',
      reconnecting: 'Перез’єднання…'
    },
    logs: 'Журнал',
    logsTitle: 'Журнал',
    logsEmpty: 'Жодного захопленого виводу.',
    logsSource: 'Який журнал',
    logsSourceConsole: 'Консоль init контейнера — чому служба всередині не запустилася',
    logsSourceSupervisor: 'Супервізор liblxc — чому контейнер так і не дійшов до запуску',
    logsNeverStarted: 'Його жодного разу не запускали, тож записаного ще нічого немає — запустіть його, і журнал буде навіть якщо запуск не вдасться.',
    logsNoTemplate: 'Шаблон ніколи не виконується, тож нічого ніколи не записував.',
    logsError: 'Журнал не вдалося захопити',

    // Стандартний діалог (раунд #156): вкладки деталей, спільні для списків CT
    // і шаблонів CT, плюс замки з поясненням.
    tabs: {
      general: 'Загальне',
      hardware: 'Обладнання',
      network: 'Мережа',
      provenance: 'Походження'
    },
    templateFlag: 'Шаблон CT',
    templateLock: 'Змінюється лише діями «Підвищити» / «Повернути до CT» — ніколи прямим редагуванням.',
    sourceLock: 'Походження, записане при народженні — ніколи не переписується; мертве джерело лишає голе посилання.',
    storageLock: 'Зафіксовано при створенні — переміщення rootfs буде в майбутньому раунді.',
    startedAt: 'Запущено',
    lastStop: 'Остання зупинка',
    editNicsTitle: 'Редагувати мережі',
    nicDisconnected: 'від’єднана'
  },
  ctTemplates: {
    title: 'Шаблони CT',
    importAction: 'Імпортувати з каталогу',
    importTitle: 'Імпорт шаблона CT з каталогу',
    importSubmit: 'Імпортувати',
    importError: 'Імпорт відхилено',
    importHint: 'Матеріалізація копіює rootfs у вибране сховище — файл каталогу лишається недоторканим. Щоб додати нові файли, спершу вивантажте їх у каталог.',
    sourceFile: 'Файл шаблона CT',
    sourceFileHint: 'Файли ct-rootfs вибраного каталогу, лише готові',
    noFiles: 'У цьому каталозі немає готових файлів ct-rootfs — вивантажте один зі сторінки каталогу',
    source: 'Файл-джерело',
    rootfsStorage: 'Сховище rootfs',
    rootfsStorageHint: "Де живе розпаковане дерево rootfs — сховище з файловою системою та достатнім вільним місцем для розпакованого розміру плюс приблизно 1 GiB запасу (інакше імпорт не вдасться).",
    resources: 'Ресурси',
    cores: 'vCPU',
    memoryMiB: 'Пам’ять (MiB)',
    cpuLimit: 'Ліміт CPU',
    cpuLimitHint: 'Еквіваленти ядер хоста (напр. 1.5); порожньо = без стелі',
    cpuUncapped: 'без стелі',
    cpuWeight: 'Вага CPU',
    hostname: 'Ім’я хоста',
    hostnameHint: 'Порожньо = назва CT',
    nameservers: 'Сервери імен DNS',
    dnsHint: 'Через кому; порожньо = успадковує від хоста',
    searchDomains: 'Домени пошуку DNS',
    dnsInherited: 'Успадковано від хоста',
    networks: 'Мережі',
    nicSlot: 'Слот NIC',
    phase: {
      materializing: 'Матеріалізується',
      ready: 'Готовий',
      deleting: 'Видаляється',
      error: 'Помилка'
    },
    exportAction: 'Експортувати в каталог',
    exportTitle: 'Експорт у каталог',
    exportSubmit: 'Експортувати',
    exportError: 'Експорт відхилено',
    exportHint: 'Пакує матеріалізований rootfs у НОВИЙ файл ct-rootfs у вибраному каталозі — шаблон лишається недоторканим.',
    exportName: 'Назва файлу',
    exportNameHint: 'Порожньо = <template>-export-<n>',
    markCt: {
      action: 'Повернути до CT',
      confirmTitle: 'Повернути «{name}» до CT?',
      confirmBody: 'Шаблон залишає цей список і повертається до списку CT, знову придатний до запуску. Доки ви не підвищите його знову, створювати з нього CT не можна.',
      confirm: 'Повернути до CT',
      moved: 'Тепер «{name}» знову CT; знайдете його в списку CT.'
    }
  },

  // OCI, хвиля 1 (Annex Q — модель «тег як гілка»): тег OCI є гілкою (рухомий
  // покажчик), дайджест — комітом; оновлення = «git fetch», завантаження =
  // розв’язати ЗАРАЗ і стягнути САМЕ той дайджест.
  oci: {
    registriesTitle: 'Реєстри OCI',
    imagesTitle: 'Образи OCI',
    provider: 'Постачальник',
    providerDockerhub: 'Docker Hub',
    providerGhcr: 'GHCR',
    providerEcr: 'Amazon ECR',
    providerQuay: 'Red Hat Quay',
    providerGeneric: 'Загальний',
    providerImmutableHint: 'Постачальник незмінний після створення — інший постачальник означає новий реєстр.',
    url: 'URL',
    urlHintPreset: 'Заповнено постачальником — перезаписуйте лише заради дзеркал.',
    urlHintRequired: 'Обов’язково для загальних реєстрів: базовий URL https://.',
    urlHintEcr: 'Обов’язково: кінцеві точки ECR залежать від акаунта й регіону — готового значення не існує.',
    credential: 'Облікові дані',
    credentialNone: 'Анонімний доступ',
    credentialHint: 'Запис у сховищі ключів типу «користувач і пароль»; воркери розв’язують його в мить використання — жодних auth-файлів на вузол.',
    nameHint: 'Назва в стилі хоста (docker.io, registry.intra); унікальна в межах скоупу, незмінна',
    addRegistry: 'Додати реєстр',
    addRegistryTitle: 'Додати реєстр OCI',
    verify: 'Перевірити',
    verifyState: 'Перевірка',
    verified: 'Перевірено',
    verifyFailed: 'Не вдалася',
    neverVerified: 'Ніколи не перевірявся',
    registryInUseError: 'У «{name}» ще є зареєстровані репозиторії — спершу видаліть їх.',
    repositories: 'Репозиторії',
    repositoriesHint: 'Реєстрація ставить гілки (теги OCI) під спостереження — нічого не завантажує. Оновлення розв’язує кожну спостережувану гілку й веде історію розв’язань.',
    noRepositories: 'На цьому реєстрі немає зареєстрованих репозиторіїв.',
    registerRepository: 'Зареєструвати репозиторій',
    repoPath: 'Шлях',
    repoPathHint: 'Шлях репозиторію в реєстрі, напр. «example» або «library/nginx»',
    branches: 'Гілки',
    branchesHint: 'Спостережувані гілки (теги OCI), через кому — напр. 1.1.0, 1.1.1',
    branch: 'Гілка',
    branchPullHint: 'Розв’язується ЗАРАЗ: завантажується дайджест, на який гілка вказує сьогодні.',
    refresh: 'Оновити',
    deleteRepository: 'Видалити репозиторій',
    reflogCount: 'Попередніх: {n}',
    noResolutions: 'Ніколи не оновлювався — жодного спостереженого розв’язання.',
    refreshFailed: 'Останнє оновлення не вдалося ({when})',
    loadError: 'Не вдалося завантажити репозиторії.',
    reference: 'Посилання',
    digest: 'Дайджест',
    digestHint: 'sha256:… — точний образ, без гілки (відокремлений)',
    size: 'Розмір',
    nodes: 'Вузли',
    detached: 'відокремлений',
    detachedHint: 'Завантажений за дайджестом, без гілки — контроль дрейфу не застосовується.',
    pulledAt: 'Завантажений',
    pull: 'Завантажити',
    pullTitle: 'Завантажити образ',
    pullHint: 'Попереднє прогрівання, ніколи не передумова: завантаження за гілкою розв’язує ЗАРАЗ і тягне САМЕ той дайджест; завантаження за дайджестом — відокремлене.',
    pullError: 'Завантаження відхилено',
    pullMode: 'Завантажити за',
    pullModeBranch: 'Гілкою (розв’язати зараз)',
    pullModeDigest: 'Дайджестом (відокремлено)',
    pullModeBranchHint: 'Чесне типове значення: як apt install — виконане пізніше, може дати інший образ.',
    pullModeDigestHint: 'Точний дайджест — відтворюваність і відкат; ціною відмови від контролю дрейфу.',

    // Схема з двома кнопками (#88, ратифіковано ввечері 2026-07-30): «з
    // реєстру» — наявне кероване завантаження, «з каталогу» матеріалізує
    // готовий архів oci-image (шлях для мереж без доступу назовні).
    importFromRegistry: 'Імпортувати з реєстру',
    importFromCatalog: 'Імпортувати з каталогу',
    importCatalogTitle: 'Імпорт образу OCI з каталогу',
    importCatalogHint: 'Шлях для мереж без доступу назовні: готовий архів oci-image (tar/tar.gz — docker-archive або oci-archive) матеріалізується у сховищі образів із посиланням catalog/<каталог>/<файл>@<дайджест>; застосунки споживають його як будь-який інший образ. Архіви вивантажуються в каталоги — цей розділ лише імпортує.',
    importCatalogFile: 'Архів',
    importCatalogFileHint: 'Готові файли oci-image вибраного каталогу.',
    importCatalogNoFiles: 'У цьому каталозі немає готових архівів oci-image — вивантажте один із деталей каталогу.',
    importCatalogError: 'Імпорт відхилено',
    registry: 'Реєстр',
    repository: 'Репозиторій',
    cacheMissing: 'Кеш OCI кластера не налаштовано — завантаження відхиляються, доки ви не задасте пул сховища.',
    setCache: 'Задати кеш',
    setCacheTitle: 'Налаштувати кеш OCI',
    setCacheHint: 'ТИПОВИЙ пул рівня кластера, який тримає блоби завантажених образів — скоуп може перевизначити його власним пулом (сторінка «Скоупи»). Зміна не гаряча, нічого не перезапускає й не переміщує блоби: вони ліниво з’являються знову при наступному запуску чи використанні.',
    cachePool: 'Пул сховища',
    changeCache: 'Змінити кеш',
    changeCacheTitle: 'Змінити пул кешу OCI',
    cacheCurrent: 'Кеш OCI кластера (типовий): {name}',
    sectionOverview: 'Огляд',
    sectionRepositories: 'Репозиторії',
    sectionExplore: 'Дослідити',
    exploreHint: 'Живий віддалений пошук у реєстрі — для Docker Hub повний (опис, завантаження, зірки), для інших постачальників за можливості. Виберіть результат, щоб прочитати повний опис і переглянути віддалені теги; з тега можна додати посилання до репозиторію TVirt.',
    exploreSearch: 'Шукати',
    exploreUnsupported: 'Цей постачальник не підтримує пошуку.',
    exploreNoResult: 'Немає відповідних репозиторіїв.',
    exploreNoTags: 'У цьому репозиторії немає відповідних тегів.',
    exploreOfficial: 'Офіційний',
    explorePulls: 'Завантажень',
    exploreStars: 'Зірки',
    exploreUpdated: 'Оновлено {when}',
    exploreLoadMore: 'Завантажити ще',
    exploreSelectHint: 'Виберіть результат: повний опис і віддалені теги завантажаться тут.',
    exploreNoDescription: 'Цей постачальник не надає опису.',
    exploreTagsTitle: 'Віддалені теги',
    exploreTagFilter: 'Шукати тег',
    exploreAddToRepo: 'Додати до репозиторію',
    exploreAdded: '{path}:{tag} тепер відстежується — див. розділ «Репозиторії».',
    addBranch: 'Додати гілку',
    purgeRequiredTitle: 'Видалити «{name}» разом з його образами?',
    purgeRequiredBody: 'Жоден застосунок цей репозиторій не споживає, але завантажені образи ще існують: видалення прибере і їхні записи, а кешовані блоби перейдуть до збирача сміття.',
    purgeConfirm: 'Видалити й образи',
    providerSelectHint: 'Виберіть тип реєстру: картка розповідає про заготовку URL і призначення.',
    providerDesc: {
      dockerhub: 'Публічний реєстр Docker: URL заповнено наперед, повний пошук з описами й лічильниками.',
      ghcr: 'GitHub Container Registry: URL заповнено наперед; акаунти використовують personal access token.',
      ecr: 'Amazon Elastic Container Registry: кінцеві точки свої для кожного акаунта й регіону — URL треба вказати.',
      quay: 'Реєстр Red Hat Quay: URL заповнено наперед.',
      generic: 'Самостійно розгорнутий реєстр (Harbor, registry:2, …): URL https:// обов’язковий.'
    },

    // Стандартний діалог (раунд #156): поля деталей образу та реєстру, яких
    // не показували колонки.
    layerCount: 'Шари',
    verifiedAt: 'Остання перевірка',
    verifyOk: 'Результат',
    verifyMessage: 'Повідомлення перевірки',

    // Модель #348/R39: образ Є дайджестом — вмістом — а registry, репозиторій і гілка є ІМЕНАМИ, які до нього ведуть.
    head: 'Вершина',
    heads: 'Вершини за архітектурою',
    listDigest: 'Дайджест списку',
    neverResolved: 'Ніколи не розв’язано',
    totalSize: 'Загальний розмір',
    reflogTitle: 'Історія розв’язань',
    usedBy: 'Використовує',
    usageLockfile: 'lockfile',
    usageRunning: 'виконується',
    evictable: 'можна вилучити',
    evict: 'Вилучити з кешу',
    evictHeadTitle: 'Вилучити {digest}?',
    evictHeadBody: 'Це поточне розв’язання щонайменше одного колектора: вилучати його законно — це лише кеш, віддалена гілка досі його віддає — але це не має статися помилково. Блоб ОДИН: вилучення спорожнює всі колектори, які його поділяють.',
    evictConfirm: 'Все одно вилучити',

    arch: 'Архітектура',
    names: 'Імена',
    noNames: 'без імені',
    views: 'Подання',
    lastView: 'останнє подання',
    evictLastViewTitle: 'Прибрати останнє посилання на {digest}?',
    evictLastViewBody: 'Це останнє подання цього вмісту: прибравши його, образ перестає існувати в TVirt, а байти ({size}) вивільняються. Це docker image rm цієї моделі — не побічний ефект, а сама операція.',
    branchesTabHint: 'Спостережувані гілки цього репозиторію: для кожної сьогоднішні вершини — по одній на архітектуру — хронологія оновлень і скільки названих нею образів є в кеші. Оновлення — це «git fetch» репозиторію: воно розв’язує всі його гілки за раз.',
    noBranches: 'У цьому репозиторії не спостерігається жодна гілка.',
    stopObserving: 'Припинити спостереження за гілкою',
    pullBranch: 'Завантажити в кеш голову branch (refresh розв\'язує, це завантажує)',
    pullDigest: 'Завантажити в кеш цей digest',
    imageCount: 'Образи',
    deleteBranchPurgeTitle: 'Залишити образи {name} без імені?',
    deleteBranchPurgeBody: 'Жоден застосунок не називає цю гілку, але деякі образи досяжні лише через неї: після видалення вони залишаться в кеші без імені, перелічені серед образів репозиторію та видимі для ручного вилучення.',
    deleteBranchPurgeConfirm: 'Видалити та залишити образи без імені',
    imagesTabHint: 'Образи цього репозиторію — вміст, тобто дайджести — видно й без вибору гілки. Образ унікальний у межах кластера: імен, які до нього ведуть, може бути кілька.',
    noImages: 'Жоден образ цього репозиторію не матеріалізовано в кеші.',
    deleteRepositoryTitle: 'Видалити {name}?',
    deleteRepositoryBody: 'Репозиторій і його гілки зникають разом із хронологією. Образи лишаються в кеші: вони втрачають лише це ім’я. Репозиторій, який називає застосунок, видалити не можна.',
    provenanceCatalog: 'каталог',
    refreshedAt: 'Оновлено',
    neverRefreshed: 'Ніколи не оновлювався',
    sectionBranches: 'Гілки',
    sectionImages: 'Образи',
    repositoriesGovernedElsewhere: 'Тут репозиторії лише переглядають: реєстрація, оновлення, спостереження за гілками та вилучення образів робляться в розділі Образи OCI.',
    gotoImages: 'Перейти до Образів OCI'
  },

  // Pod nativi (P1): the Pod list — the template's census of instances, the
  // whole-Pod lifecycle, the scale and the delete.
  pods: {
    title: 'Поди',
    containers: 'Контейнери',
    instances: 'Екземпляри',
    instancesTooltip: '{running} працює, {error} з помилкою',
    placement: 'Розміщення',
    spread: 'розподіл',
    ha: 'HA',
    templateRevision: 'ревізія',
    deleting: 'Видаляється',
    empty: 'Подів немає — створіть застосунок (один контейнер) або под із CLI (create-pod).',
    openInstances: 'Відкрити екземпляри',
    rollingRestart: 'Почерговий перезапуск',
    scale: 'Масштабувати',
    scaleTitle: 'Масштабувати {name}',
    scaleHint: 'Кількість екземплярів (0–64): угору займається найнижчий вільний номер, униз відкликається найвищий, його постійні дані зберігаються.',
    scaleError: 'Масштабування не вдалося',
    replicas: 'Репліки',
    deleteRunningError: '{name} працює — спершу зупиніть.',
    deleteInstancesIntro: 'Усі {count} екземплярів буде вилучено.',
    stateRunning: 'Працює',
    stateStopped: 'Зупинено',
    editor: {
      createTitle: 'Створити Pod',
      create: 'Створити Pod',
      editTitle: 'Змінити Pod',
      nameHint: 'DNS-1123, не більше 58 символів — екземпляри називаються <ім\'я>-<індекс>; незмінне після створення.',
      restartPolicy: 'Політика перезапуску',
      restartPolicyHint_always: 'Вузол перезапускає будь-який завершений контейнер з експоненційною затримкою (10 с → 5 хв).',
      restartPolicyHint_onFailure: 'Перезапускається лише контейнер із ненульовим кодом виходу; вихід 0 залишається у спокої.',
      restartPolicyHint_never: 'Завершений контейнер залишається як є — екземпляр завершується як succeeded або failed.',
      grace: 'Відстрочка (с)',
      graceHint: 'Межа SIGTERM → SIGKILL зупинки.',
      hostname: 'Ім\'я хоста',
      hostnameHint: 'Порожньо = ім\'я екземпляра.',
      hostnameDefault: 'ім\'я екземпляра',
      sharePid: 'Спільний простір імен PID між контейнерами',
      containersIntro: 'Init-контейнери виконуються до кінця, по черзі, перед запуском контейнерів; контейнери ділять мережу екземпляра (один IP, localhost між ними).',
      initContainers: 'Init-контейнери',
      initAdd: 'Додати init-контейнер',
      initHint: 'Кожен має завершитися з 0; збій переводить екземпляр у помилку, і вузол повторює його із затримкою.',
      containerAdd: 'Додати контейнер',
      atLeastOne: 'Pod потребує щонайменше одного контейнера.',
      duplicateNames: 'Імена контейнерів мають бути унікальними в Pod (включно з init-контейнерами).',
      containerName: 'Ім\'я контейнера',
      containerInvalid: 'Цей контейнер неповний: ім\'я (DNS-1123), образ, монтування на оголошені томи, числові ліміти й проба.',
      command: 'Команда',
      commandHint: 'Замінює entrypoint образу — один аргумент на рядок, ніколи не рядок оболонки.',
      args: 'Аргументи',
      argsHint: 'По одному на рядок (CMD образу, якщо порожньо).',
      mounts: 'Монтування',
      mountAdd: 'Додати монтування',
      mountNoVolumes: 'Спершу оголосіть том на вкладці Сховище.',
      readOnly: 'лише читання',
      resources: 'Ліміти',
      cpus: 'CPU',
      cpusHint: 'podman --cpus (напр. 1.5)',
      memory: 'Пам\'ять (MiB)',
      memoryHint: 'podman --memory',
      health: 'Проба живучості',
      healthCmd: 'Команда проби',
      healthCmdHint: 'Виконується вузлом усередині контейнера на кожному такті нагляду — один аргумент на рядок; вихід 0 = здоровий.',
      healthTimeout: 'Тайм-аут (с)',
      healthRetries: 'Спроби',
      healthRetriesHint: 'Послідовні збої, після яких вузол перезапустить контейнер.',
      ips: 'Статичні адреси',
      ipsHint: 'По одній на екземпляр, у порядку номерів — масштабування поза списком відхиляється.',
      instance: 'екземпляр',
      volumesHint: 'Томи належать Pod; шлях монтування — кожному контейнеру (вкладка Контейнери).',
      spread: 'Розподіл',
      spreadHint_preferred: 'Екземпляри на різних вузлах, коли можливо.',
      spreadHint_required: 'Екземпляри на різних вузлах, інакше масштабування відхиляється.',
      spreadHint_none: 'Лише планувальник.',
      ha: 'Висока доступність (opt-in)',
      haHint: 'Кожна постійна частина на спільному storage; якщо вузол помре, HA decider відтворить екземпляри на іншому члені (автоматичний failover, як у HA VM).',
      yes: 'так',
      no: 'ні'
    },
    detail: {
      container: 'Контейнер',
      actions: 'Дії',
      ready: 'Готовий',
      notReady: 'Не готовий',
      restarts: 'Перезапуски',
      lastRestartAt: 'Останній перезапуск:',
      backoffUntil: 'Повтор о',
      stateAbsent: 'відсутній',
      stateRunning: 'працює',
      stateTerminated: 'завершений',
      stateWaiting: 'очікує',
      init: 'init',
      noInstances: 'Немає екземплярів (реплік 0).',
      ha: 'HA',
      haHint: 'Автоматичний failover: якщо вузол помре, HA decider відтворить екземпляр на іншому члені (кожна постійна частина на спільному storage).',
      authority: 'Authority (вузол)',
      homeless: 'без authority',
      homelessHint: 'Відновлення з checkpoint залишає authority осторонь (#380): жоден вузол не обслуговує її, доки ви не масштабуєте Pod (хоча б до тієї ж кількості реплік).',
      restartContainer: 'Перезапустити лише цей контейнер (pod продовжує працювати)',
      divergingHint: 'Бажаний стан цього екземпляра відрізняється від типового стану Pod (PD-P19).',
      revisionLag: 'ревізія {applied} застосована з {current}',
      updatedInstances: '{updated}/{desired} екземплярів на цій ревізії'
    }
  }
}
